import { useState, useEffect } from "react";

export const useMediaQuery = (query) => {

	const initialValue = window.matchMedia(query).matches;
	const [matches, setMatches] = useState(initialValue);

	useEffect(() => {
		const media = window.matchMedia(query);
		if (media.matches !== matches) {
			setMatches(media.matches);
		}
		const listener = () => setMatches(media.matches);
		window.addEventListener("resize", listener);
		return () => window.removeEventListener("resize", listener);
	}, [matches, query]);

	return matches;
}